// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2paqW","col":"styles_col__3YO4g"};